import React, {Component} from 'react';
import {Switch, Route, Redirect} from "react-router-dom";
import classNames from "classnames";
import AuthPage from "./pages/auth/AuthPage/AuthPage";
import styles from "./App.scss";
import LoginPage from "./pages/login/LoginPage"
import DashboardContainer from "./pages/dashboard/Dashboard/DashboardContainer"

class App extends Component {
    render() {
        return (
            <div className={classNames('App', styles.app)}>
                <Switch>
                    <Redirect exact from="/" to="/a"/>
                    <Route path="/a/" component={DashboardContainer}/>
                    <Route path="/auth/:token" component={AuthPage}/>
                    <Route path="/login" component={LoginPage}/>
                </Switch>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js